import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {map, switchMap, tap} from "rxjs/operators";
import {ModalComponent} from "../../../components/modal/modal.component";
import {GroupV3RestService} from "../../../services/rest/v3/group-rest.service";
import {Group, MemberRole, V3GroupStudent, V3GroupTeacher} from "../../../model/v3/schools";
import {Page, Pageable} from "../../../model/rest/base";

@Component({
    selector: 'app-group-details-page',
    templateUrl: './group-details-page.component.html',
    styleUrls: ['./group-details-page.component.scss'],
    standalone: false
})
export class GroupDetailsPageComponent implements OnInit {
  @ViewChild('deleteConfirmModal') deleteConfirmModal: ModalComponent
  schoolId: number;
  groupId: number = null
  group: Group
  groupStudents: Page<V3GroupStudent>
  groupTeachers: Page<V3GroupTeacher>
  studentPageable = new Pageable(0, 5, null)
  teacherPageable = new Pageable(0, 5, null)

  constructor(activatedRoute: ActivatedRoute,
              private groupV3Rest: GroupV3RestService,
              private router: Router,
              private route: ActivatedRoute) {
    activatedRoute.paramMap.pipe(
      map( params => {
        this.schoolId = Number(params.get('schoolId'))
        this.groupId = Number(params.get('groupId'))
      }),
      switchMap(_ =>  this.loadGroupDetails())
    ).subscribe();
  }

  ngOnInit(): void {
  }

  loadGroupDetails() {
    return this.groupV3Rest.getGroup(this.schoolId, this.groupId).pipe(
      tap(group => this.group = group),
      switchMap(_ => this.loadStudents(this.studentPageable)),
      switchMap(_ => this.loadTeachers(this.teacherPageable))
    )
  }

  loadStudents(pageable: Pageable) {
    return this.groupV3Rest.getGroupMembers(this.schoolId, this.groupId, pageable, MemberRole.Student).pipe(
      tap(groupStudents => this.groupStudents = groupStudents as Page<V3GroupStudent>),
    )
  }

  loadTeachers(pageable: Pageable) {
    return this.groupV3Rest.getGroupMembers(this.schoolId, this.groupId, pageable, MemberRole.Teacher).pipe(
      tap(groupTeachers => this.groupTeachers = groupTeachers as Page<V3GroupTeacher>),
    )
  }

  getInitials() {
    return this.group?.name.split(' ').map(part => {
      return part[0]
    }).join('')
  }

  deleteGroup() {
    this.groupV3Rest.deleteGroup(this.schoolId, this.groupId).subscribe(_ => {
      this.deleteConfirmModal.hide()
      this.router.navigate(
        ['../../'],
        {relativeTo: this.route}
      ).then()
    })
  }
}
